<template>
	<div>
		<ja-loader v-if="!items.length" />
		<div
			v-else
			class="table table--simple"
			:class="{ colorize: defaultOptions.colorize }"
		>
			<div class="table__row row--header">
				<div
					class="cell__header table__cell"
					:class="getStickyClasses(true, true)"
				>
					{{ defaultOptions.firstCellText }}
				</div>

				<div
					v-for="(header, index) in tableHeaders"
					:key="index"
					class="table__cell sticky"
					:class="getStickyClasses(true, false)"
				>
					{{ header }}
				</div>
			</div>

			<div
				v-for="(column, index) in tableColumns"
				:key="index"
				class="table__row"
			>
				<div
					class="cell__header table__cell"
					:class="getStickyClasses(false, true)"
				>
					{{ column }}
				</div>

				<div v-for="k in data" :key="k.id" class="table__cell">
					{{ k[index] || defaultOptions.default }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Loader from '@ui/Loader';
export default {
	components: {
		jaLoader: Loader
	},
	props: {
		options: {
			type: Object,
			default: () => {}
		},
		items: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			defaultOptions: {
				colorize: true,
				stickyHeader: true,
				stickyColumn: true,
				// Usually empty - it is the very first cell on first row(headers) and first col(col-headers)
				firstCellText: '',
				headerKey: '',
				columnKey: '',
				dataKey: '',
				groupBy: 'id',
				valueKey: 'value',
				default: ''
			},
			maxAttempts: 32,
			numberOfCategories: 12,
			data: [],
			tableHeaders: [],
			tableColumns: {}
		};
	},
	watch: {
		items() {
			this.dataAdapter();
		}
	},
	mounted() {
		this.updateOptions();
		this.dataAdapter();
	},
	methods: {
		getStickyClasses(isHeader, isColumn) {
			const { stickyHeader, stickyColumn } = this.defaultOptions;
			const classes = ['sticky'];

			if (!stickyHeader && !stickyColumn) {
				return '';
			}

			if (stickyHeader && isHeader) {
				classes.push('sticky--top');
			}

			if (stickyColumn && isColumn) {
				classes.push('sticky--left');
			}

			return classes.join(' ');
		},
		updateOptions() {
			this.defaultOptions = { ...this.defaultOptions, ...this.options };
		},
		dataAdapter() {
			if (!this.items) {
				return;
			}

			const {
				groupBy,
				headerKey,
				columnKey,
				valueKey,
				dataKey
			} = this.defaultOptions;

			this.items.forEach((item, index) => {
				// get headers into separated array
				this.tableHeaders.push(item[headerKey]);

				// loop through the data using specified key
				item[dataKey].forEach(listData => {
					// for every element in that data use a grouping key and the columnKey
					// to generate the proper values for the first column
					this.tableColumns[listData[groupBy]] = listData[columnKey];

					// if we have something on that index - let's use it
					// otherwise create a new object that will be filled
					this.data[index] = this.data[index] || {};

					// Use data to populate the content for the rest of the table
					// for each column (index) and each row(groupBy);
					// Use valueKey to get the specified data
					this.data[index][listData[groupBy]] = listData[valueKey];
				});
			});
		}
	}
};
</script>
